import React, { Component } from "react";
import { httpRequest, URLS } from "./../network";
import { isNullOrEmpty } from "./../utils";
import "./../css/login.css";

class Login extends Component {

    constructor() {
        super();

        this.state = {
            userRut: "",
            userPass: "",
            errors: {
                userRut: false,
                userPass: false,
                errorMsg: ""
            },
            showLoader: false
        }
    }

    onChangeInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onLoginClick = () => {

        const rut = this.state.userRut;
        const pass = this.state.userPass;
        if (isNullOrEmpty(rut) || isNullOrEmpty(pass)) {

            let errors = this.state.errors;
            errors.userPass = true;
            errors.errorMsg = "No puedes dejar los campos vacios";
            this.setState({ errors: errors });
            return;
        }

        const params = { user: rut, pass: pass };
        httpRequest(URLS.LOGIN, params, "POST")
            .then ((json) => {
                
                if (!json.success) {

                    let errors = this.state.errors;
                    errors.userPass = true;
                    errors.errorMsg = "Rut o password incorrectos";
                    this.setState({ errors: errors });
                    return;
                }


                this.props.loginHanlder(json.success);
            })
            .catch( (err) => {
                console.log("err: ", err);
            });
    }

    render()
    {
		return (
			<div className="modal-dialog text-center">

                <div className="col-sm-8 main-section">
                    <div className="modal-content">


						<label className="login-title"><b>Login</b></label>

                        { /** input container */}
                        <div className="col-12 form-input">
                            <div  className="form-group has-danger">
                                <input id="userRut" name="userRut" type="text" className="form-control" placeholder="Ingresar rut"
                                    required="required" value={this.state.userRut} onChange={this.onChangeInput} />
                            </div>

                            <div className="form-group has-lock">
                                <input id="userPass" name="userPass" type="password" className="form-control" placeholder="Ingresar clave"
                                    required="required" value={this.state.userPass} onChange={this.onChangeInput} />
                            </div>
                        </div>
                        <button type="submit" className="btn btn-outline-primary" onClick={this.onLoginClick}>Entrar</button>
                    </div>

                </div>
                <br />
                
                <div
						className={
							this.state.errors.userRut ||
							this.state.errors.userPass
								? "alert alert-danger alert-dismissible fade show"
								: "alert alert-danger alert-dismissible fade"
						}
						role="alert"
					>
                        <strong>Error: </strong> {this.state.errors.errorMsg}
					</div>
                { this.state.showLoader && <div id="loader" className="loader"></div> }
			</div>
		);
  	}
}

export default Login;